define('models/calendar/item/animated-session',[
    'underscore', 'backbone', 'utils',
    // models
    'models/calendar/item',
], function(
    _, Backbone, U,
    // models
    MCalendarItem
) {

    var MAnimatedSessionItem = MCalendarItem.extend({
        blacklist: ["sup_name"],
        defaults: function() {
            return {
                name: "",
                sup_name: "",
                week: 0,
                type: MAnimatedSessionItem.type,
                duration: 0,
                calories: 0,
                distance: { unit: "km", value: 0 },
            };
        },

        computeds: {
            distanceValue: {
                deps: ["distance"],
                get: function(distance) {
                    return distance ? distance.value : 0;
                },
                set: function(value) {
                    var distance = this.get('distance') || {};
                    return {
                        distance: MAnimatedSessionItem.getDefaultDistance(value, distance.unit)
                    };
                }
            },
            distanceUnit: {
                deps: ["distance"],
                get: function(distance) {
                    return distance ? distance.unit : 'km';
                },
                set: function(unit) {
                    var distance = this.get('distance') || {};
                    return {
                        distance: MAnimatedSessionItem.getDefaultDistance(distance.value, unit)
                    };
                }
            },
            durationValue: {
                deps: ["duration"],
                get: function(val) {
                    var s = val % 60;
                    var m = Math.floor(val / 60) % 60;
                    var h = Math.floor(val / 3600);

                    return (h ? '' + h + ':' : '') + (h > 0 && m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' + s : s);
                },

                set: function(text) {
                    text = text.split(':').reverse();

                    var val = 0;

                    if (text[0]) {
                        val += parseInt(text[0], 10) || 0;
                    }
                    if (text[1]) {
                        val += parseInt(text[1], 10) * 60 || 0;
                    }
                    if (text[2]) {
                        val += parseInt(text[2], 10) * 3600 || 0;
                    }

                    return {
                        duration: val
                    };
                }
            }
        },

        updateSession: function(session, options) {
            var name = session.get('name');
            return this.set({ name: name, sup_name: name, }, options);
        },

        getWeek: function() {
            return this.get('week');
        },

    }, {
        ///////////////////
        // Class statics //
        ///////////////////
        type: 'animated',

        getUnitObject: function(value, unit) {
            return {
                unit: unit,
                value: _.isUndefined(value) ? 0 : value
            };
        },

        getDefaultDistance: function(value, unit) {
            return MAnimatedSessionItem.getUnitObject(value, unit || 'km');
        },
    });

    return MAnimatedSessionItem;
});

